<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/User' }" replace>我的</el-breadcrumb-item>
				<el-breadcrumb-item>设置密保</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="mine_list p_m_t_30 overflow small_hand" :style="{ height: height + 'px' }">
			<div class="user_box">
				<div class="p_flex p_login p_f_a p_m_t_30">
					<span class="p_m_l_30 type_size_18 ">问题一</span>
					<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="password1" placeholder="请输入问题"></el-input></div>
				</div>
				<div class="p_flex p_login p_f_a p_m_t_30">
					<span class="p_m_l_30 type_size_18 ">回答一</span>
					<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="password11" placeholder="请输入问题"></el-input></div>
				</div>
				<div class="p_flex p_login p_f_a p_m_t_30">
					<span class="p_m_l_30 type_size_18 ">问题二</span>
					<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="password2" placeholder="请输入问题"></el-input></div>
				</div>
				<div class="p_flex p_login p_f_a p_m_t_30">
					<span class="p_m_l_30 type_size_18 ">回答二</span>
					<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="password22" placeholder="请输入问题"></el-input></div>
				</div>
				<div class="p_flex p_login p_f_a p_m_t_30">
					<span class="p_m_l_30 type_size_18 ">问题三</span>
					<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="password3" placeholder="请输入问题"></el-input></div>
				</div>
				<div class="p_flex p_login p_f_a p_m_t_30">
					<span class="p_m_l_30 type_size_18 ">回答三</span>
					<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="password33" placeholder="请输入问题"></el-input></div>
				</div>
				<div class="p_flex p_f_c p_m_t_30" @click="get">
					<el-button type="success">保存</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Setting',
	data() {
		return {
			height: 0,
			password1:'',
			password11:"",
			password2:"",
			password22:"",
			password3:"",
			password33:""
		};
	},
	created(){
			var name=JSON.parse(localStorage.getItem("user"))
		 this.$request.ajax(this).post("/api/security_question",{
			 account: name.account,
			 user_type:"teacher"
		 }).then(res=>{
			//  console.log(res)
			this.password1=res.data[0].problem
			this.password2=res.data[1].problem
			this.password3=res.data[2].problem
		 })
	},
	mounted() {
		this.indexInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/Setting') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		get(){
			this.$request.ajax(this).post("/api/set_security",{  //设置密保
				one: [this.password1,this.password11],
				two: [this.password2,this.password22],
				three: [this.password3,this.password33]
			}).then(res=>{
				// console.log(res)
				this.$router.push('/User');
			})
		}
	}
};
</script>

<style lang="scss" scoped>
.mine_list {
	background: #ffffff;
}
.user_box {
	padding: 30px 0;
}
>>> .el-tag--dark.el-tag--success {
	background-color: #00af63;
	border-color: #00af63;
}
>>> .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}

>>> input::-webkit-input-placeholder {
	font-size: 18px;
}
.p_login{
	margin: 30px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/user/setting.vue